// extracted by mini-css-extract-plugin
export default {"thumbnail":"styles_thumbnail__F1MYF","icon":"styles_icon__pj4u9"};